









import { Component, Vue } from "vue-property-decorator";
import SearchForm from "@/components/inputs/SearchForm.vue";

@Component({
  components: { SearchForm }
})
export default class Home extends Vue {
  search(token: string) {
    if (token) {
      this.$router.push({ name: "search-result", query: { q: token } });
    }
  }
}
